import axios from 'axios';
import Settings from './config';

export default {
 
    lookupAddress(payload, cb) {
        axios.post(Settings.ENDPOINT + "api/address/perform-lookup" , payload)
            .then(response => {
                cb(response.data);
            });
    }
}

